export default __webpack_public_path__ + "images/pointer-yellow.37d85196b29708c343ebb67786686dbd.png";